/** @format */

import { Component, Input } from '@angular/core';
import { InStorePickupSubTextComponent } from './in-store-pickup-subtext/in-store-pickup-subtext.component';
import { SameDayDeliverySubtextComponent } from './same-day-delivery-subtext/same-day-delivery-subtext.component';
import { ShipToMeSubtextComponent } from './ship-to-me-subtext/ship-to-me-subtext.component';

@Component({
	selector: 'pdp-feature-fulfillment-button-subtext',
	templateUrl: './fulfillment-button-subtext.component.html',
	styleUrl: './fulfillment-button-subtext.component.scss',
	imports: [
		InStorePickupSubTextComponent,
		SameDayDeliverySubtextComponent,
		ShipToMeSubtextComponent
	]
})
export class FulfillmentButtonSubtextComponent {
	@Input() isBundle = false;
}
